import React, { useMemo } from 'react'
import styles from '../../styles/modules/Dashboard.module.css'
import DoughnutChart from '../Charts/DoughnutChart'

const DashboardDataCard2 = ({Icon,data,label}) => {
    const percentage = useMemo(() => {
           if (!data || data.length < 2) return 0.00;
   
           const data1 = data[0];
           const data2 = data[1];
           const diff = data2 - data1;
           return calculatePercentageIncrease(data1,data2);
       }, [data]);
   
       function calculatePercentageIncrease(previous, current) {
           if (previous === 0) {
               if (current === 0) return 0;       // No change
               return 100;                        // Full increase (can also return "New" or Infinity)
           }
   
           const increase = ((current - previous) / previous) * 100;
           return Number(increase.toFixed(2));    // Rounded to 2 decimal places
       }
    
    return (
        <div className={styles['dashboard_card_con']}>
            <div className={styles['dashboard_card_part_1']}>
                <Icon className={styles['dashboard_card_icon']} />
                <h1>{data?.length == 0 ? 0 : (data[1] + data[0])}</h1>
                <h3>{label}</h3>
            </div>
            <div className={styles['dashboard_card_part_2']}>
                <DoughnutChart labels={['Meet', 'Season']} chartData={data} height='60px' width='60px' />
               <p>+{percentage}%</p>
            </div>
        </div>
    )
}

export default DashboardDataCard2